import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

function ConfidenceBadge({ value }: { value: number }) {
  const color = value >= 0.8 ? 'bg-success/20 text-success'
    : value >= 0.5 ? 'bg-warning/20 text-warning'
    : 'bg-error/20 text-error';
  return <span className={`text-xs px-1.5 py-0.5 rounded font-mono ${color}`}>{(value * 100).toFixed(0)}%</span>;
}

export function FindingsStreamWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const findings = [...journal.findings].sort((a, b) => b.createdAt.localeCompare(a.createdAt));

  return (
    <div className="p-2 overflow-y-auto h-full space-y-2">
      {findings.length === 0 && <div className="text-tower-muted text-sm p-2">No findings yet</div>}
      {findings.map((f) => (
        <div key={f.id} className="p-2 bg-tower-bg rounded border border-tower-border/50 animate-fade-in">
          <div className="flex items-start gap-2 mb-1">
            <ConfidenceBadge value={f.confidence} />
            <span className="text-xs text-tower-muted font-mono">
              {new Date(f.createdAt).toLocaleString()} &middot; tick {f.tickIndex}
            </span>
          </div>
          <p className="text-sm text-tower-text leading-relaxed">{f.content}</p>
          {f.sources.length > 0 && (
            <div className="mt-1 flex flex-wrap gap-1">
              {f.sources.map((s, i) => (
                <span key={i} className="text-xs bg-tower-border/50 text-tower-muted px-1.5 py-0.5 rounded">{s}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
